import React from "react";
import InfoBox from "common-ui-components/components/info-box/InfoBox";
import DonutChart from "common-ui-components/components/donut-chart/DonutChart";

const OS = [
  {
    id: "Windows",
    label: "Windows",
    value: 210,
    color: "#3174A0",
  },
  {
    id: "MAC",
    label: "MAC",
    value: 120,
    color: "#49A397",
  },
  {
    id: "Linux",
    label: "Linux",
    value: 40,
    color: "#ECC353",
  },
];

const DeviceOsSummary = ({ osSummary, onFilterSelect, className }) => {
  let total = 0;

  const newOS = OS.map((os) => {
    os.value = osSummary[os.id] || 0;
    total += os.value;
    return os;
  });

  return (
    <InfoBox
      header={"Device OS Summary"}
      // headerProps={{ style: { color: "#111111" } }}
      className={className}
    >
      <DonutChart
        data={newOS}
        legend
        centerText={`${total} Devices`}
        size="12rem"
        legendPadding="0.4rem 2rem 0.4rem 0.4rem"
        onDatumClick={onFilterSelect}
      />
    </InfoBox>
  );
};

export default DeviceOsSummary;
